/**
 * `modules/action/initSubmenu.js`
 *  - サブメニューのイベント管理（クリック・ホバー対応）
 *
 * 使用方法:
 *  - import {initSubmenu} from "../modules/action/initSubmenu.js";
 *  - initSubmenu(button, listeners);
 */

import {mediaQuery} from "../../utils/index.js";
import {getLenisInstance} from "../../core/momentumScroll/lenis/lenis.js";

export function initSubmenu(button, listeners) {
  const commonTrigger = button.dataset.submenuTrigger;
  const pcTrigger = button.dataset.submenuTriggerPc || commonTrigger;
  const spTrigger = button.dataset.submenuTriggerSp || commonTrigger;
  const trigger = mediaQuery() === "pc" ? pcTrigger : spTrigger;
  if (trigger === "none") return;

  const childMenu = document.querySelector(`[data-submenu-child="${button.dataset.submenuParent}"]`);
  if (!childMenu) return;
  const childMenuLink = childMenu.querySelectorAll('a');
  const menuBg = document.querySelector('#menu-bg');

  /** サブメニューの開閉処理 */
  const toggleSubMenu = (e) => {
    e.preventDefault();
    const isOpen = button.classList.toggle("is-open");
    childMenu.classList.toggle("is-open");
    menuBg?.classList.toggle("is-open");
    // メガメニュー開時に body にフラグを付与 → .main を blur する CSS のスイッチ
    document.body.classList.toggle("is-mega-menu-open", isOpen);
    isOpen ? getLenisInstance()?.stop() : getLenisInstance()?.start();
    e.stopPropagation();
  };

  const openSubMenu = () => {
    button.classList.add("is-open");
    childMenu.classList.add("is-open");
    menuBg?.classList.add("is-open");
    document.body.classList.add("is-mega-menu-open");
    getLenisInstance()?.stop();
  }
  const closeSubMenu = () => {
    button.classList.remove("is-open");
    childMenu.classList.remove("is-open");
    menuBg?.classList.remove("is-open");
    document.body.classList.remove("is-mega-menu-open");
    getLenisInstance()?.start();
  }

  if (trigger === "hover" && mediaQuery() === "pc") {
    button.addEventListener("mouseover", openSubMenu);
    button.addEventListener("mouseout", closeSubMenu);
    listeners.push([button, "mouseover", openSubMenu]);
    listeners.push([button, "mouseout", closeSubMenu]);
  } else if (trigger === "click") {
    button.addEventListener("click", toggleSubMenu);
    listeners.push([button, "click", toggleSubMenu]);
  }

  // サブメニュー内の各リンククリック時の挙動
  childMenuLink.forEach((link) => {
    link.addEventListener("click", closeSubMenu);
    listeners.push([link, "click", closeSubMenu]);
  });
}